import {RemoteGetAccessUserManualLink} from 'data/usecases/private/external-links/user-manual/remote-get-access-user-manual';
import {GetAccessUserManualLink} from 'domain/usecases/private/external-links/user-manual/get-access-user-manual';
import {makeAuthorizeHttpClientDecoratorNoToken} from 'main/factories/decorators/authorize-http-client-decorator-factory-no-token';

import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetAccessUserManualLink = (): GetAccessUserManualLink =>
	new RemoteGetAccessUserManualLink(
		makeBFFApiUrl(ExternalLinkPoint.accessUserManual),
		makeAuthorizeHttpClientDecoratorNoToken(),
	);
